"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _frontendUtils = require("@engaging-tech/frontend-utils");

var _CardDetails = _interopRequireDefault(require("./CardDetails"));

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _Box = _interopRequireDefault(require("../../Box/Box"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

var _TextField = _interopRequireDefault(require("../../TextField/TextField"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _Flex = _interopRequireDefault(require("../../Flex/Flex"));

var _Select = _interopRequireDefault(require("../../Select/Select"));

var _getClientDevice = _interopRequireDefault(require("../../../utils/getClientDevice"));

var _TextArea = _interopRequireDefault(require("../../TextArea/TextArea"));

var _excluded = ["text", "children", "color"],
    _excluded2 = ["text", "children", "color"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ButtonText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "Form__ButtonText",
  componentId: "sc-1nv56wv-0"
})(["font-size:14px;font-weight:700;font-family:\"Centra Bold\";"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Form__StyledButton",
  componentId: "sc-1nv56wv-1"
})(["&:hover{box-shadow:", ";transform:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.elevations[1];
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? "translateY(0px)" : "translateY(0.5px)";
});
var StyledTextArea = (0, _styledComponents["default"])(_TextArea["default"]).withConfig({
  displayName: "Form__StyledTextArea",
  componentId: "sc-1nv56wv-2"
})(["padding:0px;border-top:none;textarea{height:100px;}"]);

var TextButton = function TextButton(_ref3) {
  var _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? null : _ref3$text,
      children = _ref3.children,
      color = _ref3.color,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    alignItems: "center",
    width: "auto",
    elevation: 0,
    bg: "transparent"
  }, props), /*#__PURE__*/_react["default"].createElement(ButtonText, {
    color: color
  }, children || text));
};

var PrimaryButton = function PrimaryButton(_ref4) {
  var _ref4$text = _ref4.text,
      text = _ref4$text === void 0 ? null : _ref4$text,
      _ref4$children = _ref4.children,
      children = _ref4$children === void 0 ? null : _ref4$children,
      _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? "light.0" : _ref4$color,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref4, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, (0, _extends2["default"])({
    alignItems: "center",
    width: "auto",
    bg: "#013f4b"
  }, props), /*#__PURE__*/_react["default"].createElement(ButtonText, {
    color: color,
    width: "auto"
  }, children || text));
};
/**
 * A form with a visibility toggle. We need to use this because Stripe
 * will break if we use conditional rendering.
 */


var HidableForm = _styledComponents["default"].form.withConfig({
  displayName: "Form__HidableForm",
  componentId: "sc-1nv56wv-3"
})(["display:", ";width:100%;"], function (_ref5) {
  var isVisible = _ref5.isVisible;
  return isVisible ? "block" : "none ";
});

var Form = function Form(_ref6) {
  var handleSubmit = _ref6.handleSubmit,
      errors = _ref6.errors,
      touched = _ref6.touched,
      values = _ref6.values,
      handleChange = _ref6.handleChange,
      handleBlur = _ref6.handleBlur,
      isLoading = _ref6.isLoading,
      isValid = _ref6.isValid,
      submitContent = _ref6.submitContent,
      children = _ref6.children,
      cancelContent = _ref6.cancelContent,
      helpContent = _ref6.helpContent,
      CardElement = _ref6.CardElement;

  var _useState = (0, _react.useState)(null),
      error = _useState[0],
      setError = _useState[1];

  var device = (0, _getClientDevice["default"])();

  var _useState2 = (0, _react.useState)(false),
      isComplete = _useState2[0],
      setIsComplete = _useState2[1];

  var countries = (0, _frontendUtils.getCountries)();

  var handleStripeChange = function handleStripeChange(_ref7) {
    var stripeError = _ref7.error,
        complete = _ref7.complete;
    setIsComplete(complete);
    setError(stripeError ? stripeError.message : null);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    color: "primary.0",
    justifyContent: "center"
  }), /*#__PURE__*/_react["default"].createElement(HidableForm, {
    onSubmit: handleSubmit,
    isVisible: !isLoading
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 2
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    label: "Cardholder's Name",
    width: 1 / 1,
    name: "cardholderName",
    id: "cardholder-name",
    borderRadius: "4px 4px 0px 0px",
    type: "text",
    value: values.cardholderName,
    error: touched.cardholderName && errors.cardholderName,
    onChange: handleChange,
    onBlur: handleBlur
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    width: 1 / 1
  })), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 2
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    label: "Email Address",
    width: 1 / 1,
    borderRadius: "4px 4px 0px 0px",
    name: "emailAddress",
    id: "email-address",
    type: "email",
    value: values.emailAddress,
    error: touched.emailAddress && errors.emailAddress,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 2
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    label: "Company Name",
    width: 1 / 1,
    borderRadius: "4px 4px 0px 0px",
    name: "companyName",
    id: "company-name",
    helperText: "Optional",
    type: "text",
    value: values.companyName,
    error: touched.companyName && errors.companyName,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 2
  }, /*#__PURE__*/_react["default"].createElement(StyledTextArea, {
    label: "Address",
    width: 1 / 1,
    name: "addressFirstLine",
    borderRadius: "4px 4px 0px 0px",
    id: "address-first-line",
    type: "text",
    value: values.addressFirstLine,
    error: touched.addressFirstLine && errors.addressFirstLine,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    mb: 2,
    justifyContent: "space-between",
    flexDirection: ["column", "row"]
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    label: "Post code",
    wrapperProps: {
      width: device === "MOBILE" ? "100%" : "48%"
    },
    borderRadius: "4px 4px 0px 0px",
    name: "postcode",
    id: "postcode",
    type: "text",
    value: values.postcode,
    error: touched.postcode && errors.postcode,
    onChange: handleChange,
    onBlur: handleBlur
  }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    label: "City",
    wrapperProps: {
      width: device === "MOBILE" ? "100%" : "48%"
    },
    name: "city",
    borderRadius: "4px 4px 0px 0px",
    id: "city",
    type: "text",
    value: values.city,
    error: touched.city && errors.city,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 26
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    name: "country",
    id: "country",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.country,
    label: "Country"
  }, countries.map(function (country) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: country.code,
      value: country.code
    }, country.name);
  }))), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 2
  }, /*#__PURE__*/_react["default"].createElement(_CardDetails["default"], {
    onChange: handleStripeChange,
    CardElement: CardElement
  })), helpContent || /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    mt: 1,
    mb: 3,
    fontSize: 3,
    color: "dark.2"
  }, "If you need any help with your purchase, please get in touch with our team at:", " ", /*#__PURE__*/_react["default"].createElement("a", {
    textDecoration: "none",
    color: "primary.0",
    href: "mailto:support@workl.co"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "primary.0",
    fontSize: 3
  }, "support@workl.co"))), children, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: 1 / 1,
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 3
  }, /*#__PURE__*/_react["default"].createElement(PrimaryButton, {
    type: "submit",
    disabled: !isValid || !isComplete || error || isLoading,
    bg: !isValid || !isComplete || error || isLoading ? "primary.2" : "primary.0",
    ml: 2,
    width: "auto",
    p: 20
  }, submitContent.text), /*#__PURE__*/_react["default"].createElement(TextButton, {
    width: "auto",
    elevation: 0,
    onClick: cancelContent.action,
    color: "primary.0"
  }, cancelContent.text))));
};

var _default = Form;
exports["default"] = _default;